import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeseven-courses',
  templateUrl: './homeseven-courses.component.html',
  styleUrls: ['./homeseven-courses.component.scss']
})
export class HomesevenCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
